import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { getJobs, deleteJob, toggleJob } from '../services/api';

const tagColors = { Featured: { bg: '#e8f0ff', color: '#0066FF' }, Hot: { bg: '#fff0f0', color: '#ef4444' }, New: { bg: '#e6fff6', color: '#00C896' } };

export default function Jobs() {
  const [jobs, setJobs]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState('');

  useEffect(() => {
    getJobs()
      .then(data => { setJobs(data.jobs || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this job?')) return;
    await deleteJob(id);
    setJobs(jobs.filter(j => j._id !== id));
  };

  const handleToggle = async (id, isActive) => {
    await toggleJob(id, !isActive);
    setJobs(jobs.map(j => j._id === id ? { ...j, isActive: !isActive } : j));
  };

  const filtered = jobs.filter(j =>
    j.title?.toLowerCase().includes(search.toLowerCase()) ||
    j.company?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Layout>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h2 style={{ fontWeight: 800, color: '#0A1628', margin: '0 0 4px' }}>Jobs</h2>
          <p style={{ color: '#888', fontSize: 14, margin: 0 }}>{jobs.length} total job listings</p>
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#fff', border: '1.5px solid #eef0f8', borderRadius: 10, padding: '10px 14px', marginBottom: 20, maxWidth: 360 }}>
        <i className="fa fa-search" style={{ color: '#aaa' }}></i>
        <input type="text" placeholder="Search jobs..." value={search} onChange={e => setSearch(e.target.value)}
          style={{ border: 'none', outline: 'none', fontSize: 13, background: 'transparent', width: '100%' }} />
      </div>

      <div style={{ background: '#fff', borderRadius: 16, border: '1.5px solid #eef0f8', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f8faff' }}>
              {['Job Title', 'Company', 'Type', 'Tag', 'Status', 'Posted', 'Actions'].map(h => (
                <th key={h} style={{ padding: '14px 16px', textAlign: 'left', fontSize: 12, fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: 0.5 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} style={{ padding: '32px', textAlign: 'center', color: '#aaa' }}><i className="fa fa-spinner fa-spin me-2"></i>Loading...</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={7} style={{ padding: '32px', textAlign: 'center', color: '#aaa' }}>No jobs found</td></tr>
            ) : filtered.map((j) => (
              <tr key={j._id} style={{ borderTop: '1px solid #f5f5f5' }}>
                <td style={{ padding: '14px 16px', fontSize: 13, fontWeight: 600, color: '#0A1628' }}>{j.title}</td>
                <td style={{ padding: '14px 16px', fontSize: 13, color: '#555' }}>{j.company}</td>
                <td style={{ padding: '14px 16px', fontSize: 12, color: '#888' }}>{j.type}</td>
                <td style={{ padding: '14px 16px' }}>
                  <span style={{ fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 50, background: tagColors[j.tag]?.bg || '#f5f5f5', color: tagColors[j.tag]?.color || '#888' }}>{j.tag}</span>
                </td>
                <td style={{ padding: '14px 16px' }}>
                  <span style={{ fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 50, background: j.isActive ? '#e6fff6' : '#f5f5f5', color: j.isActive ? '#00C896' : '#aaa' }}>
                    {j.isActive ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td style={{ padding: '14px 16px', fontSize: 12, color: '#888' }}>{new Date(j.createdAt).toLocaleDateString()}</td>
                <td style={{ padding: '14px 16px' }}>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={() => handleToggle(j._id, j.isActive)} style={{ padding: '5px 12px', borderRadius: 8, border: 'none', background: j.isActive ? '#fff8e6' : '#e6fff6', color: j.isActive ? '#f59e0b' : '#00C896', fontWeight: 600, fontSize: 11, cursor: 'pointer' }}>
                      {j.isActive ? 'Deactivate' : 'Activate'}
                    </button>
                    <button onClick={() => handleDelete(j._id)} style={{ padding: '5px 12px', borderRadius: 8, border: 'none', background: '#fff0f0', color: '#ef4444', fontWeight: 600, fontSize: 11, cursor: 'pointer' }}>
                      <i className="fa fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}
